import { Record } from 'immutable';
import { construct, fields, resolve } from '../helpers/LinkMapper';
import trainTime from '../lib/TrainTime';
import ReservationJourney from './ReservationJourney';

const Reservation = new Record({
    reservationId: null,
    orderId: null,
    bookingReference: null,
    collectionReference: null,
    expiry: null,
    outwardJourney: new ReservationJourney(),
    returnJourney: new ReservationJourney(),
    isCancelled: false,
    isExpired: false,
    created: null,
});

Object.assign(Reservation.prototype, {
    getBookingDate() {
        return this.created.format('ddd DD MMM HH:mm');
    },

    getCollectionReference() {
        return this.collectionReference;
    },

    getOutwardDate() {
        const date = this.outwardJourney.getFirstLeg().departure;
        return trainTime(date).format('ddd, DD MMM YYYY');
    },

    isReturn() {
        return !!this.returnJourney;
    },

    getIsCancelled() {
        return this.isCancelled;
    }
});

Reservation.fromJSON = function(json) {
    const res = construct(Reservation, json, {
        reservationId: fields.number,
        orderId: fields.number,
        bookingReference: fields.string,
        collectionReference: fields.string,
        expiry: resolve.with(trainTime),
        outwardJourney: resolve.as(ReservationJourney),
        returnJourney: resolve.as(ReservationJourney),
        isCancelled: fields.bool,
        isExpired: fields.bool,
        created: resolve.with(trainTime),
    });

    return res;
};

export default Reservation;



// WEBPACK FOOTER //
// ./src/records/Reservation.js